const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const styles = require('./404.less')

class Error404Page extends React.Component {

    getChildContext() {
        return {
            page: {
                id: 'notfound',
            },
        }
    }

    renderDescription() {
        const { children } = this.props

        if (children) {
            return children
        }

        return (
            <p>Please check the address and try again.</p>
        )
    }

    render() {
        // inline require cuz of circular reference
        const Page = require('app/page')

        const { title, nav_props } = this.props

        return (
            <Page nav_props={nav_props} className={styles.scope}>
                <div className="structure">
                    <h1>{title}</h1>
                    {this.renderDescription()}
                </div>
            </Page>
        )
    }

}

Error404Page.propTypes = {
    title: PropTypes.string,
    nav_props: PropTypes.object,
    children: PropTypes.element,
}

Error404Page.childContextTypes = {
    page: PropTypes.object,
}

Error404Page.defaultProps = {
    title: 'We couldn’t find what you’re looking for.',
}

module.exports = withStyles(styles)(Error404Page)
